(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`.cvg-error_vOODg{align-items:center;color:#e34949;display:flex;line-height:1;margin:12px 0;min-height:50px}.cvg-cancel_7P252,.cvg-reset_hKjbf,.cvg-submit_JxN-h{cursor:pointer;-webkit-user-select:none;user-select:none}.cvg-cancel_7P252{background:center/60% no-repeat url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' fill='%23555' stroke-width='1' stroke='%23555' stroke-linejoin='round'/%3E%3C/svg%3E");color:#fff;flex:0 0 50px;margin-right:12px}.cvg-reset_hKjbf{background-color:#555;border-radius:8px;color:#fff;flex:1;height:50px}.cvg-submit_JxN-h{align-items:center;background-color:var(--theme-color);border-radius:8px;color:#fff;display:flex;flex:1;font-weight:500;height:50px;justify-content:center;text-transform:uppercase}.cvg-submit_JxN-h:disabled{background-color:#ddd;cursor:default}.cvg-submit_JxN-h svg[data-icon=loader]{--loader-max-width: 50px;--loader-fill-color: #fff}.cvg-email_TTCD3 input{--input-focus-border-color: var(--theme-color)}.cvg-buttons_dCxnB{display:flex;margin:24px 0 0}.cvg-pincode_GXQJr{display:flex;justify-content:space-between;margin:0 -2%}.cvg-pincode_GXQJr>input{-moz-appearance:none;appearance:none;box-shadow:0 0 0 1px #ccc;border-radius:6px;margin:0 2%;max-width:50px;outline:none;padding:3% 2%;resize:none;text-align:center;transition:transform .2s;width:100%;-webkit-appearance:none}.cvg-pincode_GXQJr>input:focus{box-shadow:0 0 0 2px var(--theme-color);transform:scale(1.2)}.cvg-pincode_GXQJr>input:disabled{background-color:#eee;color:#ccc}.cvg-code_-D8MI{animation:.25s ease-in cvg-slideIn_DjmpG}.cvg-code_-D8MI>p span{display:block;font-size:.875rem;font-weight:700;margin:3px 0 6px;min-height:1.5rem}.cvg-buttons_cqHr6{display:flex;margin:24px 0 0}@keyframes cvg-slideIn_DjmpG{0%{transform:translate(150%)}to{transform:translate(0)}}`)),document.head.appendChild(e)}}catch(r){console.error("vite-plugin-css-injected-by-js",r)}})();
import Er, { useRef as _r, useReducer as Gr, useEffect as ir } from "react";
import { useCustomContext as ie, useSubmit as or, CustomContextProvider as Jr } from "@cvg/react-hooks";
import Hr from "@cvg/localization-util";
import { isEmail as Xr } from "@cvg/validators";
import { Loader as Zr, Input as Qr } from "@cvg/react-components";
function et(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var qe = { exports: {} }, _e = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sr;
function rt() {
  if (sr)
    return _e;
  sr = 1;
  var t = Er, f = Symbol.for("react.element"), p = Symbol.for("react.fragment"), u = Object.prototype.hasOwnProperty, b = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function h(v, m, y) {
    var d, o = {}, _ = null, g = null;
    y !== void 0 && (_ = "" + y), m.key !== void 0 && (_ = "" + m.key), m.ref !== void 0 && (g = m.ref);
    for (d in m)
      u.call(m, d) && !l.hasOwnProperty(d) && (o[d] = m[d]);
    if (v && v.defaultProps)
      for (d in m = v.defaultProps, m)
        o[d] === void 0 && (o[d] = m[d]);
    return { $$typeof: f, type: v, key: _, ref: g, props: o, _owner: b.current };
  }
  return _e.Fragment = p, _e.jsx = h, _e.jsxs = h, _e;
}
var Ce = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cr;
function tt() {
  return cr || (cr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Er, f = Symbol.for("react.element"), p = Symbol.for("react.portal"), u = Symbol.for("react.fragment"), b = Symbol.for("react.strict_mode"), l = Symbol.for("react.profiler"), h = Symbol.for("react.provider"), v = Symbol.for("react.context"), m = Symbol.for("react.forward_ref"), y = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), o = Symbol.for("react.memo"), _ = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), B = Symbol.iterator, M = "@@iterator";
    function V(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = B && e[B] || e[M];
      return typeof r == "function" ? r : null;
    }
    var U = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function q(e) {
      {
        for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), E = 1; E < r; E++)
          a[E - 1] = arguments[E];
        z("error", e, a);
      }
    }
    function z(e, r, a) {
      {
        var E = U.ReactDebugCurrentFrame, $ = E.getStackAddendum();
        $ !== "" && (r += "%s", a = a.concat([$]));
        var F = a.map(function(I) {
          return String(I);
        });
        F.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, F);
      }
    }
    var L = !1, s = !1, te = !1, ye = !1, be = !1, ue;
    ue = Symbol.for("react.module.reference");
    function he(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === u || e === l || be || e === b || e === y || e === d || ye || e === g || L || s || te || typeof e == "object" && e !== null && (e.$$typeof === _ || e.$$typeof === o || e.$$typeof === h || e.$$typeof === v || e.$$typeof === m || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ue || e.getModuleId !== void 0));
    }
    function le(e, r, a) {
      var E = e.displayName;
      if (E)
        return E;
      var $ = r.displayName || r.name || "";
      return $ !== "" ? a + "(" + $ + ")" : a;
    }
    function fe(e) {
      return e.displayName || "Context";
    }
    function X(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && q("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case u:
          return "Fragment";
        case p:
          return "Portal";
        case l:
          return "Profiler";
        case b:
          return "StrictMode";
        case y:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case v:
            var r = e;
            return fe(r) + ".Consumer";
          case h:
            var a = e;
            return fe(a._context) + ".Provider";
          case m:
            return le(e, e.render, "ForwardRef");
          case o:
            var E = e.displayName || null;
            return E !== null ? E : X(e.type) || "Memo";
          case _: {
            var $ = e, F = $._payload, I = $._init;
            try {
              return X(I(F));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, ne = 0, Z, re, oe, de, n, c, T;
    function P() {
    }
    P.__reactDisabledLog = !0;
    function C() {
      {
        if (ne === 0) {
          Z = console.log, re = console.info, oe = console.warn, de = console.error, n = console.group, c = console.groupCollapsed, T = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: P,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        ne++;
      }
    }
    function k() {
      {
        if (ne--, ne === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, e, {
              value: Z
            }),
            info: H({}, e, {
              value: re
            }),
            warn: H({}, e, {
              value: oe
            }),
            error: H({}, e, {
              value: de
            }),
            group: H({}, e, {
              value: n
            }),
            groupCollapsed: H({}, e, {
              value: c
            }),
            groupEnd: H({}, e, {
              value: T
            })
          });
        }
        ne < 0 && q("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var S = U.ReactCurrentDispatcher, R;
    function x(e, r, a) {
      {
        if (R === void 0)
          try {
            throw Error();
          } catch ($) {
            var E = $.stack.trim().match(/\n( *(at )?)/);
            R = E && E[1] || "";
          }
        return `
` + R + e;
      }
    }
    var j = !1, w;
    {
      var G = typeof WeakMap == "function" ? WeakMap : Map;
      w = new G();
    }
    function i(e, r) {
      if (!e || j)
        return "";
      {
        var a = w.get(e);
        if (a !== void 0)
          return a;
      }
      var E;
      j = !0;
      var $ = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var F;
      F = S.current, S.current = null, C();
      try {
        if (r) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (ae) {
              E = ae;
            }
            Reflect.construct(e, [], I);
          } else {
            try {
              I.call();
            } catch (ae) {
              E = ae;
            }
            e.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ae) {
            E = ae;
          }
          e();
        }
      } catch (ae) {
        if (ae && E && typeof ae.stack == "string") {
          for (var O = ae.stack.split(`
`), J = E.stack.split(`
`), N = O.length - 1, W = J.length - 1; N >= 1 && W >= 0 && O[N] !== J[W]; )
            W--;
          for (; N >= 1 && W >= 0; N--, W--)
            if (O[N] !== J[W]) {
              if (N !== 1 || W !== 1)
                do
                  if (N--, W--, W < 0 || O[N] !== J[W]) {
                    var ee = `
` + O[N].replace(" at new ", " at ");
                    return e.displayName && ee.includes("<anonymous>") && (ee = ee.replace("<anonymous>", e.displayName)), typeof e == "function" && w.set(e, ee), ee;
                  }
                while (N >= 1 && W >= 0);
              break;
            }
        }
      } finally {
        j = !1, S.current = F, k(), Error.prepareStackTrace = $;
      }
      var me = e ? e.displayName || e.name : "", ar = me ? x(me) : "";
      return typeof e == "function" && w.set(e, ar), ar;
    }
    function Q(e, r, a) {
      return i(e, !1);
    }
    function pe(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function se(e, r, a) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return i(e, pe(e));
      if (typeof e == "string")
        return x(e);
      switch (e) {
        case y:
          return x("Suspense");
        case d:
          return x("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case m:
            return Q(e.render);
          case o:
            return se(e.type, r, a);
          case _: {
            var E = e, $ = E._payload, F = E._init;
            try {
              return se(F($), r, a);
            } catch {
            }
          }
        }
      return "";
    }
    var Se = Object.prototype.hasOwnProperty, ze = {}, Ke = U.ReactDebugCurrentFrame;
    function Re(e) {
      if (e) {
        var r = e._owner, a = se(e.type, e._source, r ? r.type : null);
        Ke.setExtraStackFrame(a);
      } else
        Ke.setExtraStackFrame(null);
    }
    function wr(e, r, a, E, $) {
      {
        var F = Function.call.bind(Se);
        for (var I in e)
          if (F(e, I)) {
            var O = void 0;
            try {
              if (typeof e[I] != "function") {
                var J = Error((E || "React class") + ": " + a + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw J.name = "Invariant Violation", J;
              }
              O = e[I](r, I, E, a, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (N) {
              O = N;
            }
            O && !(O instanceof Error) && (Re($), q("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", E || "React class", a, I, typeof O), Re(null)), O instanceof Error && !(O.message in ze) && (ze[O.message] = !0, Re($), q("Failed %s type: %s", a, O.message), Re(null));
          }
      }
    }
    var Or = Array.isArray;
    function ke(e) {
      return Or(e);
    }
    function kr(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, a = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return a;
      }
    }
    function Ir(e) {
      try {
        return Ge(e), !1;
      } catch {
        return !0;
      }
    }
    function Ge(e) {
      return "" + e;
    }
    function Je(e) {
      if (Ir(e))
        return q("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", kr(e)), Ge(e);
    }
    var Ee = U.ReactCurrentOwner, jr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, He, Xe, Ie;
    Ie = {};
    function $r(e) {
      if (Se.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Yr(e) {
      if (Se.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ar(e, r) {
      if (typeof e.ref == "string" && Ee.current && r && Ee.current.stateNode !== r) {
        var a = X(Ee.current.type);
        Ie[a] || (q('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Ee.current.type), e.ref), Ie[a] = !0);
      }
    }
    function Fr(e, r) {
      {
        var a = function() {
          He || (He = !0, q("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: a,
          configurable: !0
        });
      }
    }
    function Dr(e, r) {
      {
        var a = function() {
          Xe || (Xe = !0, q("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        a.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: a,
          configurable: !0
        });
      }
    }
    var Mr = function(e, r, a, E, $, F, I) {
      var O = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: f,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: a,
        props: I,
        // Record the component responsible for creating this element.
        _owner: F
      };
      return O._store = {}, Object.defineProperty(O._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(O, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: E
      }), Object.defineProperty(O, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: $
      }), Object.freeze && (Object.freeze(O.props), Object.freeze(O)), O;
    };
    function Br(e, r, a, E, $) {
      {
        var F, I = {}, O = null, J = null;
        a !== void 0 && (Je(a), O = "" + a), Yr(r) && (Je(r.key), O = "" + r.key), $r(r) && (J = r.ref, Ar(r, $));
        for (F in r)
          Se.call(r, F) && !jr.hasOwnProperty(F) && (I[F] = r[F]);
        if (e && e.defaultProps) {
          var N = e.defaultProps;
          for (F in N)
            I[F] === void 0 && (I[F] = N[F]);
        }
        if (O || J) {
          var W = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          O && Fr(I, W), J && Dr(I, W);
        }
        return Mr(e, O, J, $, E, Ee.current, I);
      }
    }
    var je = U.ReactCurrentOwner, Ze = U.ReactDebugCurrentFrame;
    function ve(e) {
      if (e) {
        var r = e._owner, a = se(e.type, e._source, r ? r.type : null);
        Ze.setExtraStackFrame(a);
      } else
        Ze.setExtraStackFrame(null);
    }
    var $e;
    $e = !1;
    function Ye(e) {
      return typeof e == "object" && e !== null && e.$$typeof === f;
    }
    function Qe() {
      {
        if (je.current) {
          var e = X(je.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Vr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), a = e.lineNumber;
          return `

Check your code at ` + r + ":" + a + ".";
        }
        return "";
      }
    }
    var er = {};
    function qr(e) {
      {
        var r = Qe();
        if (!r) {
          var a = typeof e == "string" ? e : e.displayName || e.name;
          a && (r = `

Check the top-level render call using <` + a + ">.");
        }
        return r;
      }
    }
    function rr(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var a = qr(r);
        if (er[a])
          return;
        er[a] = !0;
        var E = "";
        e && e._owner && e._owner !== je.current && (E = " It was passed a child from " + X(e._owner.type) + "."), ve(e), q('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', a, E), ve(null);
      }
    }
    function tr(e, r) {
      {
        if (typeof e != "object")
          return;
        if (ke(e))
          for (var a = 0; a < e.length; a++) {
            var E = e[a];
            Ye(E) && rr(E, r);
          }
        else if (Ye(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var $ = V(e);
          if (typeof $ == "function" && $ !== e.entries)
            for (var F = $.call(e), I; !(I = F.next()).done; )
              Ye(I.value) && rr(I.value, r);
        }
      }
    }
    function Nr(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var a;
        if (typeof r == "function")
          a = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === m || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === o))
          a = r.propTypes;
        else
          return;
        if (a) {
          var E = X(r);
          wr(a, e.props, "prop", E, e);
        } else if (r.PropTypes !== void 0 && !$e) {
          $e = !0;
          var $ = X(r);
          q("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", $ || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && q("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Lr(e) {
      {
        for (var r = Object.keys(e.props), a = 0; a < r.length; a++) {
          var E = r[a];
          if (E !== "children" && E !== "key") {
            ve(e), q("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", E), ve(null);
            break;
          }
        }
        e.ref !== null && (ve(e), q("Invalid attribute `ref` supplied to `React.Fragment`."), ve(null));
      }
    }
    function nr(e, r, a, E, $, F) {
      {
        var I = he(e);
        if (!I) {
          var O = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var J = Vr($);
          J ? O += J : O += Qe();
          var N;
          e === null ? N = "null" : ke(e) ? N = "array" : e !== void 0 && e.$$typeof === f ? (N = "<" + (X(e.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : N = typeof e, q("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", N, O);
        }
        var W = Br(e, r, a, $, F);
        if (W == null)
          return W;
        if (I) {
          var ee = r.children;
          if (ee !== void 0)
            if (E)
              if (ke(ee)) {
                for (var me = 0; me < ee.length; me++)
                  tr(ee[me], e);
                Object.freeze && Object.freeze(ee);
              } else
                q("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              tr(ee, e);
        }
        return e === u ? Lr(W) : Nr(W), W;
      }
    }
    function Wr(e, r, a) {
      return nr(e, r, a, !0);
    }
    function Ur(e, r, a) {
      return nr(e, r, a, !1);
    }
    var zr = Ur, Kr = Wr;
    Ce.Fragment = u, Ce.jsx = zr, Ce.jsxs = Kr;
  }()), Ce;
}
process.env.NODE_ENV === "production" ? qe.exports = rt() : qe.exports = tt();
var D = qe.exports, Ne = { exports: {} }, Pe = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ur;
function nt() {
  if (ur)
    return Y;
  ur = 1;
  var t = typeof Symbol == "function" && Symbol.for, f = t ? Symbol.for("react.element") : 60103, p = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, b = t ? Symbol.for("react.strict_mode") : 60108, l = t ? Symbol.for("react.profiler") : 60114, h = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, m = t ? Symbol.for("react.async_mode") : 60111, y = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, o = t ? Symbol.for("react.suspense") : 60113, _ = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, B = t ? Symbol.for("react.lazy") : 60116, M = t ? Symbol.for("react.block") : 60121, V = t ? Symbol.for("react.fundamental") : 60117, U = t ? Symbol.for("react.responder") : 60118, q = t ? Symbol.for("react.scope") : 60119;
  function z(s) {
    if (typeof s == "object" && s !== null) {
      var te = s.$$typeof;
      switch (te) {
        case f:
          switch (s = s.type, s) {
            case m:
            case y:
            case u:
            case l:
            case b:
            case o:
              return s;
            default:
              switch (s = s && s.$$typeof, s) {
                case v:
                case d:
                case B:
                case g:
                case h:
                  return s;
                default:
                  return te;
              }
          }
        case p:
          return te;
      }
    }
  }
  function L(s) {
    return z(s) === y;
  }
  return Y.AsyncMode = m, Y.ConcurrentMode = y, Y.ContextConsumer = v, Y.ContextProvider = h, Y.Element = f, Y.ForwardRef = d, Y.Fragment = u, Y.Lazy = B, Y.Memo = g, Y.Portal = p, Y.Profiler = l, Y.StrictMode = b, Y.Suspense = o, Y.isAsyncMode = function(s) {
    return L(s) || z(s) === m;
  }, Y.isConcurrentMode = L, Y.isContextConsumer = function(s) {
    return z(s) === v;
  }, Y.isContextProvider = function(s) {
    return z(s) === h;
  }, Y.isElement = function(s) {
    return typeof s == "object" && s !== null && s.$$typeof === f;
  }, Y.isForwardRef = function(s) {
    return z(s) === d;
  }, Y.isFragment = function(s) {
    return z(s) === u;
  }, Y.isLazy = function(s) {
    return z(s) === B;
  }, Y.isMemo = function(s) {
    return z(s) === g;
  }, Y.isPortal = function(s) {
    return z(s) === p;
  }, Y.isProfiler = function(s) {
    return z(s) === l;
  }, Y.isStrictMode = function(s) {
    return z(s) === b;
  }, Y.isSuspense = function(s) {
    return z(s) === o;
  }, Y.isValidElementType = function(s) {
    return typeof s == "string" || typeof s == "function" || s === u || s === y || s === l || s === b || s === o || s === _ || typeof s == "object" && s !== null && (s.$$typeof === B || s.$$typeof === g || s.$$typeof === h || s.$$typeof === v || s.$$typeof === d || s.$$typeof === V || s.$$typeof === U || s.$$typeof === q || s.$$typeof === M);
  }, Y.typeOf = z, Y;
}
var A = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lr;
function at() {
  return lr || (lr = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, f = t ? Symbol.for("react.element") : 60103, p = t ? Symbol.for("react.portal") : 60106, u = t ? Symbol.for("react.fragment") : 60107, b = t ? Symbol.for("react.strict_mode") : 60108, l = t ? Symbol.for("react.profiler") : 60114, h = t ? Symbol.for("react.provider") : 60109, v = t ? Symbol.for("react.context") : 60110, m = t ? Symbol.for("react.async_mode") : 60111, y = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, o = t ? Symbol.for("react.suspense") : 60113, _ = t ? Symbol.for("react.suspense_list") : 60120, g = t ? Symbol.for("react.memo") : 60115, B = t ? Symbol.for("react.lazy") : 60116, M = t ? Symbol.for("react.block") : 60121, V = t ? Symbol.for("react.fundamental") : 60117, U = t ? Symbol.for("react.responder") : 60118, q = t ? Symbol.for("react.scope") : 60119;
    function z(i) {
      return typeof i == "string" || typeof i == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      i === u || i === y || i === l || i === b || i === o || i === _ || typeof i == "object" && i !== null && (i.$$typeof === B || i.$$typeof === g || i.$$typeof === h || i.$$typeof === v || i.$$typeof === d || i.$$typeof === V || i.$$typeof === U || i.$$typeof === q || i.$$typeof === M);
    }
    function L(i) {
      if (typeof i == "object" && i !== null) {
        var Q = i.$$typeof;
        switch (Q) {
          case f:
            var pe = i.type;
            switch (pe) {
              case m:
              case y:
              case u:
              case l:
              case b:
              case o:
                return pe;
              default:
                var se = pe && pe.$$typeof;
                switch (se) {
                  case v:
                  case d:
                  case B:
                  case g:
                  case h:
                    return se;
                  default:
                    return Q;
                }
            }
          case p:
            return Q;
        }
      }
    }
    var s = m, te = y, ye = v, be = h, ue = f, he = d, le = u, fe = B, X = g, H = p, ne = l, Z = b, re = o, oe = !1;
    function de(i) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), n(i) || L(i) === m;
    }
    function n(i) {
      return L(i) === y;
    }
    function c(i) {
      return L(i) === v;
    }
    function T(i) {
      return L(i) === h;
    }
    function P(i) {
      return typeof i == "object" && i !== null && i.$$typeof === f;
    }
    function C(i) {
      return L(i) === d;
    }
    function k(i) {
      return L(i) === u;
    }
    function S(i) {
      return L(i) === B;
    }
    function R(i) {
      return L(i) === g;
    }
    function x(i) {
      return L(i) === p;
    }
    function j(i) {
      return L(i) === l;
    }
    function w(i) {
      return L(i) === b;
    }
    function G(i) {
      return L(i) === o;
    }
    A.AsyncMode = s, A.ConcurrentMode = te, A.ContextConsumer = ye, A.ContextProvider = be, A.Element = ue, A.ForwardRef = he, A.Fragment = le, A.Lazy = fe, A.Memo = X, A.Portal = H, A.Profiler = ne, A.StrictMode = Z, A.Suspense = re, A.isAsyncMode = de, A.isConcurrentMode = n, A.isContextConsumer = c, A.isContextProvider = T, A.isElement = P, A.isForwardRef = C, A.isFragment = k, A.isLazy = S, A.isMemo = R, A.isPortal = x, A.isProfiler = j, A.isStrictMode = w, A.isSuspense = G, A.isValidElementType = z, A.typeOf = L;
  }()), A;
}
var fr;
function Cr() {
  return fr || (fr = 1, process.env.NODE_ENV === "production" ? Pe.exports = nt() : Pe.exports = at()), Pe.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Ae, dr;
function it() {
  if (dr)
    return Ae;
  dr = 1;
  var t = Object.getOwnPropertySymbols, f = Object.prototype.hasOwnProperty, p = Object.prototype.propertyIsEnumerable;
  function u(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function b() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var h = {}, v = 0; v < 10; v++)
        h["_" + String.fromCharCode(v)] = v;
      var m = Object.getOwnPropertyNames(h).map(function(d) {
        return h[d];
      });
      if (m.join("") !== "0123456789")
        return !1;
      var y = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        y[d] = d;
      }), Object.keys(Object.assign({}, y)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Ae = b() ? Object.assign : function(l, h) {
    for (var v, m = u(l), y, d = 1; d < arguments.length; d++) {
      v = Object(arguments[d]);
      for (var o in v)
        f.call(v, o) && (m[o] = v[o]);
      if (t) {
        y = t(v);
        for (var _ = 0; _ < y.length; _++)
          p.call(v, y[_]) && (m[y[_]] = v[y[_]]);
      }
    }
    return m;
  }, Ae;
}
var Fe, pr;
function Le() {
  if (pr)
    return Fe;
  pr = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Fe = t, Fe;
}
var De, vr;
function Sr() {
  return vr || (vr = 1, De = Function.call.bind(Object.prototype.hasOwnProperty)), De;
}
var Me, mr;
function ot() {
  if (mr)
    return Me;
  mr = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var f = Le(), p = {}, u = Sr();
    t = function(l) {
      var h = "Warning: " + l;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {
      }
    };
  }
  function b(l, h, v, m, y) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in l)
        if (u(l, d)) {
          var o;
          try {
            if (typeof l[d] != "function") {
              var _ = Error(
                (m || "React class") + ": " + v + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof l[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw _.name = "Invariant Violation", _;
            }
            o = l[d](h, d, m, v, null, f);
          } catch (B) {
            o = B;
          }
          if (o && !(o instanceof Error) && t(
            (m || "React class") + ": type specification of " + v + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof o + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), o instanceof Error && !(o.message in p)) {
            p[o.message] = !0;
            var g = y ? y() : "";
            t(
              "Failed " + v + " type: " + o.message + (g ?? "")
            );
          }
        }
    }
  }
  return b.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (p = {});
  }, Me = b, Me;
}
var Be, gr;
function st() {
  if (gr)
    return Be;
  gr = 1;
  var t = Cr(), f = it(), p = Le(), u = Sr(), b = ot(), l = function() {
  };
  process.env.NODE_ENV !== "production" && (l = function(v) {
    var m = "Warning: " + v;
    typeof console < "u" && console.error(m);
    try {
      throw new Error(m);
    } catch {
    }
  });
  function h() {
    return null;
  }
  return Be = function(v, m) {
    var y = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function o(n) {
      var c = n && (y && n[y] || n[d]);
      if (typeof c == "function")
        return c;
    }
    var _ = "<<anonymous>>", g = {
      array: U("array"),
      bigint: U("bigint"),
      bool: U("boolean"),
      func: U("function"),
      number: U("number"),
      object: U("object"),
      string: U("string"),
      symbol: U("symbol"),
      any: q(),
      arrayOf: z,
      element: L(),
      elementType: s(),
      instanceOf: te,
      node: he(),
      objectOf: be,
      oneOf: ye,
      oneOfType: ue,
      shape: fe,
      exact: X
    };
    function B(n, c) {
      return n === c ? n !== 0 || 1 / n === 1 / c : n !== n && c !== c;
    }
    function M(n, c) {
      this.message = n, this.data = c && typeof c == "object" ? c : {}, this.stack = "";
    }
    M.prototype = Error.prototype;
    function V(n) {
      if (process.env.NODE_ENV !== "production")
        var c = {}, T = 0;
      function P(k, S, R, x, j, w, G) {
        if (x = x || _, w = w || R, G !== p) {
          if (m) {
            var i = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw i.name = "Invariant Violation", i;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Q = x + ":" + R;
            !c[Q] && // Avoid spamming the console because they are often not actionable except for lib authors
            T < 3 && (l(
              "You are manually calling a React.PropTypes validation function for the `" + w + "` prop on `" + x + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), c[Q] = !0, T++);
          }
        }
        return S[R] == null ? k ? S[R] === null ? new M("The " + j + " `" + w + "` is marked as required " + ("in `" + x + "`, but its value is `null`.")) : new M("The " + j + " `" + w + "` is marked as required in " + ("`" + x + "`, but its value is `undefined`.")) : null : n(S, R, x, j, w);
      }
      var C = P.bind(null, !1);
      return C.isRequired = P.bind(null, !0), C;
    }
    function U(n) {
      function c(T, P, C, k, S, R) {
        var x = T[P], j = Z(x);
        if (j !== n) {
          var w = re(x);
          return new M(
            "Invalid " + k + " `" + S + "` of type " + ("`" + w + "` supplied to `" + C + "`, expected ") + ("`" + n + "`."),
            { expectedType: n }
          );
        }
        return null;
      }
      return V(c);
    }
    function q() {
      return V(h);
    }
    function z(n) {
      function c(T, P, C, k, S) {
        if (typeof n != "function")
          return new M("Property `" + S + "` of component `" + C + "` has invalid PropType notation inside arrayOf.");
        var R = T[P];
        if (!Array.isArray(R)) {
          var x = Z(R);
          return new M("Invalid " + k + " `" + S + "` of type " + ("`" + x + "` supplied to `" + C + "`, expected an array."));
        }
        for (var j = 0; j < R.length; j++) {
          var w = n(R, j, C, k, S + "[" + j + "]", p);
          if (w instanceof Error)
            return w;
        }
        return null;
      }
      return V(c);
    }
    function L() {
      function n(c, T, P, C, k) {
        var S = c[T];
        if (!v(S)) {
          var R = Z(S);
          return new M("Invalid " + C + " `" + k + "` of type " + ("`" + R + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return V(n);
    }
    function s() {
      function n(c, T, P, C, k) {
        var S = c[T];
        if (!t.isValidElementType(S)) {
          var R = Z(S);
          return new M("Invalid " + C + " `" + k + "` of type " + ("`" + R + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return V(n);
    }
    function te(n) {
      function c(T, P, C, k, S) {
        if (!(T[P] instanceof n)) {
          var R = n.name || _, x = de(T[P]);
          return new M("Invalid " + k + " `" + S + "` of type " + ("`" + x + "` supplied to `" + C + "`, expected ") + ("instance of `" + R + "`."));
        }
        return null;
      }
      return V(c);
    }
    function ye(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? l(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : l("Invalid argument supplied to oneOf, expected an array.")), h;
      function c(T, P, C, k, S) {
        for (var R = T[P], x = 0; x < n.length; x++)
          if (B(R, n[x]))
            return null;
        var j = JSON.stringify(n, function(G, i) {
          var Q = re(i);
          return Q === "symbol" ? String(i) : i;
        });
        return new M("Invalid " + k + " `" + S + "` of value `" + String(R) + "` " + ("supplied to `" + C + "`, expected one of " + j + "."));
      }
      return V(c);
    }
    function be(n) {
      function c(T, P, C, k, S) {
        if (typeof n != "function")
          return new M("Property `" + S + "` of component `" + C + "` has invalid PropType notation inside objectOf.");
        var R = T[P], x = Z(R);
        if (x !== "object")
          return new M("Invalid " + k + " `" + S + "` of type " + ("`" + x + "` supplied to `" + C + "`, expected an object."));
        for (var j in R)
          if (u(R, j)) {
            var w = n(R, j, C, k, S + "." + j, p);
            if (w instanceof Error)
              return w;
          }
        return null;
      }
      return V(c);
    }
    function ue(n) {
      if (!Array.isArray(n))
        return process.env.NODE_ENV !== "production" && l("Invalid argument supplied to oneOfType, expected an instance of array."), h;
      for (var c = 0; c < n.length; c++) {
        var T = n[c];
        if (typeof T != "function")
          return l(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + oe(T) + " at index " + c + "."
          ), h;
      }
      function P(C, k, S, R, x) {
        for (var j = [], w = 0; w < n.length; w++) {
          var G = n[w], i = G(C, k, S, R, x, p);
          if (i == null)
            return null;
          i.data && u(i.data, "expectedType") && j.push(i.data.expectedType);
        }
        var Q = j.length > 0 ? ", expected one of type [" + j.join(", ") + "]" : "";
        return new M("Invalid " + R + " `" + x + "` supplied to " + ("`" + S + "`" + Q + "."));
      }
      return V(P);
    }
    function he() {
      function n(c, T, P, C, k) {
        return H(c[T]) ? null : new M("Invalid " + C + " `" + k + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return V(n);
    }
    function le(n, c, T, P, C) {
      return new M(
        (n || "React class") + ": " + c + " type `" + T + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + C + "`."
      );
    }
    function fe(n) {
      function c(T, P, C, k, S) {
        var R = T[P], x = Z(R);
        if (x !== "object")
          return new M("Invalid " + k + " `" + S + "` of type `" + x + "` " + ("supplied to `" + C + "`, expected `object`."));
        for (var j in n) {
          var w = n[j];
          if (typeof w != "function")
            return le(C, k, S, j, re(w));
          var G = w(R, j, C, k, S + "." + j, p);
          if (G)
            return G;
        }
        return null;
      }
      return V(c);
    }
    function X(n) {
      function c(T, P, C, k, S) {
        var R = T[P], x = Z(R);
        if (x !== "object")
          return new M("Invalid " + k + " `" + S + "` of type `" + x + "` " + ("supplied to `" + C + "`, expected `object`."));
        var j = f({}, T[P], n);
        for (var w in j) {
          var G = n[w];
          if (u(n, w) && typeof G != "function")
            return le(C, k, S, w, re(G));
          if (!G)
            return new M(
              "Invalid " + k + " `" + S + "` key `" + w + "` supplied to `" + C + "`.\nBad object: " + JSON.stringify(T[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(n), null, "  ")
            );
          var i = G(R, w, C, k, S + "." + w, p);
          if (i)
            return i;
        }
        return null;
      }
      return V(c);
    }
    function H(n) {
      switch (typeof n) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !n;
        case "object":
          if (Array.isArray(n))
            return n.every(H);
          if (n === null || v(n))
            return !0;
          var c = o(n);
          if (c) {
            var T = c.call(n), P;
            if (c !== n.entries) {
              for (; !(P = T.next()).done; )
                if (!H(P.value))
                  return !1;
            } else
              for (; !(P = T.next()).done; ) {
                var C = P.value;
                if (C && !H(C[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ne(n, c) {
      return n === "symbol" ? !0 : c ? c["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && c instanceof Symbol : !1;
    }
    function Z(n) {
      var c = typeof n;
      return Array.isArray(n) ? "array" : n instanceof RegExp ? "object" : ne(c, n) ? "symbol" : c;
    }
    function re(n) {
      if (typeof n > "u" || n === null)
        return "" + n;
      var c = Z(n);
      if (c === "object") {
        if (n instanceof Date)
          return "date";
        if (n instanceof RegExp)
          return "regexp";
      }
      return c;
    }
    function oe(n) {
      var c = re(n);
      switch (c) {
        case "array":
        case "object":
          return "an " + c;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + c;
        default:
          return c;
      }
    }
    function de(n) {
      return !n.constructor || !n.constructor.name ? _ : n.constructor.name;
    }
    return g.checkPropTypes = b, g.resetWarningCache = b.resetWarningCache, g.PropTypes = g, g;
  }, Be;
}
var Ve, yr;
function ct() {
  if (yr)
    return Ve;
  yr = 1;
  var t = Le();
  function f() {
  }
  function p() {
  }
  return p.resetWarningCache = f, Ve = function() {
    function u(h, v, m, y, d, o) {
      if (o !== t) {
        var _ = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw _.name = "Invariant Violation", _;
      }
    }
    u.isRequired = u;
    function b() {
      return u;
    }
    var l = {
      array: u,
      bigint: u,
      bool: u,
      func: u,
      number: u,
      object: u,
      string: u,
      symbol: u,
      any: u,
      arrayOf: b,
      element: u,
      elementType: u,
      instanceOf: b,
      node: u,
      objectOf: b,
      oneOf: b,
      oneOfType: b,
      shape: b,
      exact: b,
      checkPropTypes: p,
      resetWarningCache: f
    };
    return l.PropTypes = l, l;
  }, Ve;
}
if (process.env.NODE_ENV !== "production") {
  var ut = Cr(), lt = !0;
  Ne.exports = st()(ut.isElement, lt);
} else
  Ne.exports = ct()();
var ft = Ne.exports;
const ge = /* @__PURE__ */ et(ft), ce = {
  DefaultException: "Your request failed - please try again.",
  NotAuthorizedException: "Your verification code has expired.",
  UserLambdaValidationException: "Your email must be associated with ___.",
  VerificationCodeIncorrect: "Incorrect code - please try again."
}, We = {
  NotAuthorizedException: "NotAuthorizedException",
  UserLambdaValidationException: "UserLambdaValidationException",
  VerificationCodeIncorrect: "VerificationCodeIncorrect"
}, Te = {
  employee: "employee",
  fcp: "fcp",
  reviewer: "reviewer",
  supporter: "supporter"
}, we = {
  enterEmail: "enterEmail",
  confirmCode: "confirmCode"
}, Oe = 6, dt = "Back", pt = "Code", vt = "Continue", mt = "Submit", gt = {
  "a reviewer": "a reviewer",
  "a supporter": "a supporter",
  "an employee": "an employee",
  "an FCP": "an FCP",
  Back: dt,
  Code: pt,
  Continue: vt,
  "Enter verification code sent to:": "Enter verification code sent to:",
  "Incorrect code - please try again.": "Incorrect code - please try again.",
  "Please enter email": "Please enter email",
  "Sign In": "Sign In",
  "Start Over": "Start Over",
  Submit: mt,
  "Your email must be associated with ___.": "Your email must be associated with ___.",
  "Your request failed - please try again.": "Your request failed - please try again.",
  "Your session has expired. Please sign in again.": "Your session has expired. Please sign in again.",
  "Your verification code has expired.": "Your verification code has expired."
}, yt = "ተመለስ", bt = "ኮድ", ht = "ቀጥል", Et = "አስገባ", _t = {
  "a reviewer": "ገምጋሚ",
  "a supporter": "ደጋፊ",
  "an employee": "ሰራተኛ",
  "an FCP": "ቤተ ክርስቲያን",
  Back: yt,
  Code: bt,
  Continue: ht,
  "Enter verification code sent to:": "የተላከውን የማረጋገጫ ኮድ ያስገቡ",
  "Incorrect code - please try again.": "የተሳሳተ ኮድ - እባክዎ እንደገና ይሞክሩ",
  "Please enter email": "እባክህ/ሽ ኢሜል አስገባ",
  "Sign In": "ይግቡ",
  "Start Over": "እንደገና ጀምር",
  Submit: Et,
  "Your email must be associated with ___.": "ኢሜልዎ ከ___ ጋር መያያዝ አለበት።",
  "Your request failed - please try again.": "ጥያቄዎ አልተሳካም - እባክዎ እንደገና ይሞክሩ።",
  "Your session has expired. Please sign in again.": "ክፍለ ጊዜዎ ጊዜው አልፎበታል። እባክዎ እንደገና ይግቡ።",
  "Your verification code has expired.": "የማረጋገጫ ኮድዎ ጊዜው አልፎበታል።"
}, Ct = "Zurück", St = "Code", Rt = "Weitermachen", Pt = "Einreichen", Tt = {
  "a reviewer": "ein Rezensent",
  "a supporter": "ein Unterstützer",
  "an employee": "ein Angestellter",
  "an FCP": "ein FCP",
  Back: Ct,
  Code: St,
  Continue: Rt,
  "Enter verification code sent to:": "Geben Sie den Bestätigungscode ein, der an folgende Adresse gesendet wurde:",
  "Incorrect code - please try again.": "Falscher Code, bitte versuchen Sie es erneut.",
  "Please enter email": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "Sign In": "Anmelden",
  "Start Over": "Von vorn anfangen",
  Submit: Pt,
  "Your email must be associated with ___.": "Ihre E-Mail-Adresse muss mit ___ verknüpft sein.",
  "Your request failed - please try again.": "Ihre Anfrage ist fehlgeschlagen. Bitte versuchen Sie es erneut.",
  "Your session has expired. Please sign in again.": "Deine Sitzung ist abgelaufen. Bitte neu anmelden.",
  "Your verification code has expired.": "Ihr Bestätigungscode ist abgelaufen."
}, xt = "Atrás", wt = "Código", Ot = "Siguiente", kt = "Enviar", It = {
  "a reviewer": "un revisor",
  "a supporter": "un partidario",
  "an employee": "un empleado",
  "an FCP": "un FCP",
  Back: xt,
  Code: wt,
  Continue: Ot,
  "Enter verification code sent to:": "Ingrese el código de verificación enviado a:",
  "Incorrect code - please try again.": "Código Incorrecto, por favor intenta de nuevo.",
  "Please enter email": "Por favor, ingrese email",
  "Sign In": "Iniciar Sesión",
  "Start Over": "Comenzar de nuevo",
  Submit: kt,
  "Your email must be associated with ___.": "Su correo electrónico debe estar asociado a un contacto de ___ en Connect.",
  "Your request failed - please try again.": "Su solicitud falló; inténtelo de nuevo.",
  "Your session has expired. Please sign in again.": "Su sesión ha caducado. Por favor inicia sesión nuevamente.",
  "Your verification code has expired.": "Tu código de verificación ha caducado."
}, jt = "Retour", $t = "Code", Yt = "Continuer", At = "Soumettre", Ft = {
  "a reviewer": "un critique",
  "a supporter": "un partisan",
  "an employee": "un employé",
  "an FCP": "un FCP",
  Back: jt,
  Code: $t,
  Continue: Yt,
  "Enter verification code sent to:": "Entrez le code de vérification envoyé à:",
  "Incorrect code - please try again.": "Code incorrect, merci de réessayer.",
  "Please enter email": "Veuillez saisir votre e-mail",
  "Sign In": "Identification",
  "Start Over": "Recommencer",
  Submit: At,
  "Your email must be associated with ___.": "Votre email doit être associé à ___.",
  "Your request failed - please try again.": "Votre demande a échoué. Veuillez réessayer.",
  "Your session has expired. Please sign in again.": "Votre session a expiré. Veuillez vous reconnecter.",
  "Your verification code has expired.": "Votre code de vérification a expiré."
}, Dt = "Kembali", Mt = "Kode", Bt = "Lanjutkan", Vt = "Kirim", qt = {
  "a reviewer": "seorang pengulas",
  "a supporter": "seorang pendukung",
  "an employee": "seorang pegawai",
  "an FCP": "PPA",
  Back: Dt,
  Code: Mt,
  Continue: Bt,
  "Enter verification code sent to:": "Kode verifikasi untuk masuk telah dikirim ke:",
  "Incorrect code - please try again.": "Kode salah - Mohon coba lagi",
  "Please enter email": "Masukkan alamat email",
  "Sign In": "Masuk",
  "Start Over": "Mulai dari awal",
  Submit: Vt,
  "Your email must be associated with ___.": "Email Anda harus terhubung dengan ___.",
  "Your request failed - please try again.": "Permintaan gagal - Mohon coba lagi",
  "Your session has expired. Please sign in again.": "Sesi Anda telah berakhir. Silakan masuk lagi.",
  "Your verification code has expired.": "Kode verifikasi Anda telah kadaluarsa"
}, Nt = "뒤쪽에", Lt = "암호", Wt = "계속하다", Ut = "제출하다", zt = {
  "a reviewer": "평론가",
  "a supporter": "후원자",
  "an employee": "직원",
  "an FCP": "FCP",
  Back: Nt,
  Code: Lt,
  Continue: Wt,
  "Enter verification code sent to:": "다음 주소로 전송된 인증 코드를 입력하세요:",
  "Incorrect code - please try again.": "잘못된 코드입니다. 다시 시도해 주세요.",
  "Please enter email": "이메일을 입력해주세요",
  "Sign In": "로그인",
  "Start Over": "다시 시작하다",
  Submit: Ut,
  "Your email must be associated with ___.": "귀하의 이메일은 ___과(와) 연결되어 있어야 합니다.",
  "Your request failed - please try again.": "요청이 실패했습니다. 다시 시도해 주세요.",
  "Your session has expired. Please sign in again.": "기간이 만료되었습니다. 다시 로그인해 주세요.",
  "Your verification code has expired.": "인증 코드가 만료되었습니다."
}, Kt = "နောက်သို့", Gt = "ကုဒ်", Jt = "‌ရှေ့ဆက်ပါ", Ht = "တင်သွင်းပါ", Xt = {
  "a reviewer": "ဝေဖန်သူ",
  "a supporter": "ထောက်ခံသူ",
  "an employee": "ဝန်ထမ်းတစ်ဦး",
  "an FCP": "ဘုရားကျောင်းတစ်ခု",
  Back: Kt,
  Code: Gt,
  Continue: Jt,
  "Enter verification code sent to:": "…သို့ ပို့ပေးထားသည့် အတည်ပြုကုဒ်ကို ရိုက်ထည့်ပါ",
  "Incorrect code - please try again.": "ကုဒ်မှားယွင်းနေသည် -  နောက်တစ်ကြိမ်ထပ်ကြိုးစားပါ။",
  "Please enter email": "အီးမေးလ် ရိုက်ထည့်ပါ",
  "Sign In": "ဝင်ရောက်ပါ",
  "Start Over": "စတင်ပါ",
  Submit: Ht,
  "Your email must be associated with ___.": "သင့်အီးမေးလ်သည် ___ နှင့် ဆက်စပ်နေရပါမည်။",
  "Your request failed - please try again.": "တောင်းဆိုမှု မအောင်မြင်ပါ. နောက်တစ်ကြိမ်ထပ်ကြိုးစားပါ",
  "Your session has expired. Please sign in again.": "သင့်စက်ရှင် သက်တမ်းကုန်သွားပါပြီ။ ကျေးဇူးပြု၍ ထပ်မံဝင်ရောက်ပါ။",
  "Your verification code has expired.": "အတည်ပြုကုဒ် သက်တမ်းကုန်နေပြီ"
}, Zt = "Rug", Qt = "Code", en = "Doorgaan", rn = "Indienen", tn = {
  "a reviewer": "een recensent",
  "a supporter": "een voorstander",
  "an employee": "een werknemer",
  "an FCP": "een FCP",
  Back: Zt,
  Code: Qt,
  Continue: en,
  "Enter verification code sent to:": "Voer de verificatiecode in die is verzonden naar:",
  "Incorrect code - please try again.": "Onjuiste code. Probeer het opnieuw.",
  "Please enter email": "Voer uw e-mailadres in",
  "Sign In": "Aanmelden",
  "Start Over": "Begin opnieuw",
  Submit: rn,
  "Your email must be associated with ___.": "Uw e-mailadres moet gekoppeld zijn aan ___.",
  "Your request failed - please try again.": "Uw verzoek is mislukt. Probeer het opnieuw.",
  "Your session has expired. Please sign in again.": "Uw sessie is verlopen. Meld u opnieuw aan.",
  "Your verification code has expired.": "Uw verificatiecode is verlopen."
}, nn = "Tilbake", an = "Kode", on = "Fortsette", sn = "Sende inn", cn = {
  "a reviewer": "en anmelder",
  "a supporter": "en støttespiller",
  "an employee": "en ansatt",
  "an FCP": "en FCP",
  Back: nn,
  Code: an,
  Continue: on,
  "Enter verification code sent to:": "Skriv inn bekreftelseskode sendt til:",
  "Incorrect code - please try again.": "Feil kode, vennligst prøv igjen.",
  "Please enter email": "Vennligst skriv inn e-post",
  "Sign In": "Logg inn",
  "Start Over": "Begynne på nytt",
  Submit: sn,
  "Your email must be associated with ___.": "E-postadressen din må være knyttet til ___.",
  "Your request failed - please try again.": "Forespørselen din mislyktes - prøv igjen.",
  "Your session has expired. Please sign in again.": "Økten din har utløpt. Logg på igjen.",
  "Your verification code has expired.": "Bekreftelseskoden din er utløpt."
}, un = "Duubatti deebisi", ln = "Koodii", fn = "Itti fufi", dn = "Galchi", pn = {
  "a reviewer": "gamaaggamaa ta’e",
  "a supporter": "a supporter",
  "an employee": "an employee",
  "an FCP": "an FCP",
  Back: un,
  Code: ln,
  Continue: fn,
  "Enter verification code sent to:": "Koodii mirkaneeffannaa tti ergame galchi",
  "Incorrect code - please try again.": "Koodii sirrii miti. Mee irra deebi'ii yaali",
  "Please enter email": "Mee imeelii galchi",
  "Sign In": "Seeni",
  "Start Over": "Jalaqabamee jira( jalqabbiin xumuramee jira)",
  Submit: dn,
  "Your email must be associated with ___.": "Your email must be associated with ___.",
  "Your request failed - please try again.": "Gaafiin kee hin milkoofne.  mee irra deebi'ii yaali.",
  "Your session has expired. Please sign in again.": "Kutaan kee yeroon isaa darbe. Mee ammas galmaa'aa.",
  "Your verification code has expired.": "Koodiin mirkaneeffannaa kee yeroon itti darbee jira"
}, vn = "Voltar", mn = "Código:", gn = "Continuar", yn = "Enviar", bn = {
  "a reviewer": "um revisor",
  "a supporter": "um apoiador",
  "an employee": "um empregado",
  "an FCP": "uma FCP",
  Back: vn,
  Code: mn,
  Continue: gn,
  "Enter verification code sent to:": "Insira o código de verificação enviado para:",
  "Incorrect code - please try again.": "Código incorreto, por favor tente novamente",
  "Please enter email": "Por favor, insira seu e-mail",
  "Sign In": "Entrar",
  "Start Over": "Recomeçar",
  Submit: yn,
  "Your email must be associated with ___.": "Seu e-mail deve estar associada à ___.",
  "Your request failed - please try again.": "Sua solicitação falhou - por favor tente novamente.",
  "Your session has expired. Please sign in again.": "Sua sessão expirou. Faça login novamente.",
  "Your verification code has expired.": "Seu código de verificação expirou."
}, hn = "පසුපසට යන්න", En = "කේතය", _n = "ඉදිරියට යන්න", Cn = "ඉදිරිපත් කරන්න", Sn = {
  "a reviewer": "විචාරකයෙක්",
  "a supporter": "ආධාරකරුවෙක්",
  "an employee": "සේවකයෙක්",
  "an FCP": "FCP",
  Back: hn,
  Code: En,
  Continue: _n,
  "Enter verification code sent to:": "...වෙත එවා ඇති තහවුරු කිරීමේ කේතය ඇතුල් කරන්න",
  "Incorrect code - please try again.": "වැරදි කේතයකි - කරුණාකර නැවත උත්සහ කරන්න",
  "Please enter email": "කරුණාකර ඔබේ ඊතැපෑල ඇතුලත් කරන්න",
  "Sign In": "ඇතුල් වෙන්න",
  "Start Over": "නැවත ආරම්භ කරන්න",
  Submit: Cn,
  "Your email must be associated with ___.": "ඔබගේ විද්‍යුත් තැපෑල ___ සමÕ සම්බන්ධ විය යුතුය -",
  "Your request failed - please try again.": "ඔබේ ඉල්ලීම අසාර්ථක විය - කරුණාකර නැවත උත්සහ කරන්න",
  "Your session has expired. Please sign in again.": "ඔබගේ සැසිය කල් ඉකුත් වී ඇත. කරුණාකර නැවත පුරන්න.",
  "Your verification code has expired.": "ඔබේ තහවුරු කිරීමේ කේතය කල් ඉකුත් වී ඇත"
}, Rn = "Tillbaka", Pn = "Koda", Tn = "Fortsätta", xn = "Skicka in", wn = {
  "a reviewer": "en recensent",
  "a supporter": "en supporter",
  "an employee": "en anställd",
  "an FCP": "en FCP",
  Back: Rn,
  Code: Pn,
  Continue: Tn,
  "Enter verification code sent to:": "Ange verifieringskoden skickad till:",
  "Incorrect code - please try again.": "Fel kod, var snäll och försök igen.",
  "Please enter email": "Vänligen ange e-post",
  "Sign In": "Logga in",
  "Start Over": "Börja om",
  Submit: xn,
  "Your email must be associated with ___.": "Din e-postadress måste vara kopplad till ___.",
  "Your request failed - please try again.": "Din begäran misslyckades - försök igen.",
  "Your session has expired. Please sign in again.": "Din session har gått ut. Logga in igen.",
  "Your verification code has expired.": "Din verifieringskod har upphört att gälla."
}, On = "Nyuma", kn = "Namba ya Utambulisho", In = "Endelea", jn = "Wasilisha", $n = {
  "a reviewer": "mhakiki",
  "a supporter": "msaidizi",
  "an employee": "mfanyakazi",
  "an FCP": "FCP",
  Back: On,
  Code: kn,
  Continue: In,
  "Enter verification code sent to:": "Ingiza nambari ya uthibitisho iliyotumwa kwa:",
  "Incorrect code - please try again.": "Namba ya udhibitisho imekosewa-tafadhali jaribu tena.",
  "Please enter email": "Tafadhali Ingiza barua pepe yako",
  "Sign In": "Ingia",
  "Start Over": "Rudia tena",
  Submit: jn,
  "Your email must be associated with ___.": "Barua pepe yako inatakiwa kuhusiana na ___.",
  "Your request failed - please try again.": "Ombi lako limeshindikana-tafadhali jaribu tena.",
  "Your session has expired. Please sign in again.": "Muda wa kipindi chako umeisha. Tafadhali ingia tena.",
  "Your verification code has expired.": "Nambari yako ya  kuthibitisha imeisha muda wake."
}, Yn = "กลับ", An = "รหัส", Fn = "ดำเนินการต่อ", Dn = "ส่ง", Mn = {
  "a reviewer": "ผู้วิจารณ์",
  "a supporter": "ผู้สนับสนุน",
  "an employee": "พนักงาน",
  "an FCP": "โบสถ์",
  Back: Yn,
  Code: An,
  Continue: Fn,
  "Enter verification code sent to:": "ใส่รหัสยืนยันที่ได้รับใน:",
  "Incorrect code - please try again.": "รหัสไม่ถูกต้อง- กรุณาลองอีกครั้ง",
  "Please enter email": "กรุณาใส่อีเมลล์",
  "Sign In": "เข้าใช้",
  "Start Over": "เริ่มใหม่อีกครั้ง",
  Submit: Dn,
  "Your email must be associated with ___.": "อีเมลของคุณต้องเชื่อมโยงกับ___",
  "Your request failed - please try again.": "คำขอล้มเหลว-กรุณาลองอีกครั้ง",
  "Your session has expired. Please sign in again.": "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
  "Your verification code has expired.": "รหัสยืนยันของคุณหมดอายุ"
}, Bn = {
  en: {
    name: "English",
    values: gt
  },
  am: {
    name: "አማርኛ",
    values: _t
  },
  de: {
    name: "Deutsch",
    values: Tt
  },
  es: {
    name: "Español",
    values: It
  },
  fr: {
    name: "Français",
    values: Ft
  },
  id: {
    name: "bahasa Indonesia",
    values: qt
  },
  ko: {
    name: "한국어",
    values: zt
  },
  my: {
    name: "ဗမာ",
    values: Xt
  },
  nl: {
    name: "Nederlands",
    values: tn
  },
  no: {
    name: "Norsk",
    values: cn
  },
  om: {
    name: "Oromiffa",
    values: pn
  },
  pt: {
    name: "Português",
    values: bn
  },
  si: {
    name: "සිංහල",
    values: Sn
  },
  sv: {
    name: "Svenska",
    values: wn
  },
  sw: {
    name: "Kiswahili",
    values: $n
  },
  th: {
    name: "ไทย",
    values: Mn
  }
}, K = Hr(Bn), Rr = (t) => {
  t.current && setTimeout(() => t.current.scrollIntoView({ behavior: "smooth" }), 250);
}, Pr = Object.freeze({
  EMAIL: "email",
  ERROR: "error",
  NOTIFICATION: "notification"
}), Vn = "cvg-error_vOODg", qn = {
  error: Vn
}, Tr = () => {
  const { error: t, languageId: f } = ie(), p = () => {
    if (!t)
      return "";
    const { code: u, message: b } = t, l = (b == null ? void 0 : b.toLowerCase()) || "";
    return u !== We.UserLambdaValidationException ? K.getValue(ce[u] || ce.DefaultException, f) : l.includes(Te.supporter) ? K.getValue(ce[u], f, K.getValue("a supporter", f)) : l.includes(Te.employee) ? K.getValue(ce[u], f, K.getValue("an employee", f)) : l.includes(Te.fcp) ? K.getValue(ce[u], f, K.getValue("an FCP", f)) : l.includes(Te.reviewer) ? K.getValue(ce[u], f, K.getValue("a reviewer", f)) : K.getValue(ce.DefaultException, f);
  };
  return /* @__PURE__ */ D.jsx("p", { className: qn.error, "data-testid": Pr.ERROR, children: p() });
}, Nn = () => {
  var p;
  const { auth: t, languageId: f } = ie();
  return (p = t.isSessionExpired) != null && p.call(t) ? /* @__PURE__ */ D.jsx("p", { children: K.getValue("Your session has expired. Please sign in again.", f) }) : null;
}, Ln = "cvg-cancel_7P252", Wn = "cvg-reset_hKjbf", Un = "cvg-submit_JxN-h", Ue = {
  cancel: Ln,
  reset: Wn,
  submit: Un
}, xr = ({ disabled: t, label: f }) => {
  const { languageId: p, isSubmitting: u } = ie();
  return /* @__PURE__ */ D.jsx("button", { className: Ue.submit, type: "submit", disabled: t, children: u ? /* @__PURE__ */ D.jsx(Zr, {}) : K.getValue(f, p) });
}, zn = "cvg-email_TTCD3", Kn = "cvg-buttons_dCxnB", br = {
  email: zn,
  buttons: Kn
}, Gn = () => {
  const { auth: t, email: f, isSubmitting: p, languageId: u, setEmail: b, submitEmail: l } = ie(), h = _r(), v = !f || !Xr({ value: f }) || p;
  return /* @__PURE__ */ D.jsxs("form", { className: br.email, onSubmit: (m) => l({ auth: t, e: m, email: f, languageId: u }), children: [
    /* @__PURE__ */ D.jsx(Nn, {}),
    /* @__PURE__ */ D.jsx(Tr, {}),
    /* @__PURE__ */ D.jsx(
      Qr,
      {
        "data-testid": Pr.EMAIL,
        label: K.getValue("Please enter email", u),
        name: "email",
        onChange: (m) => b(m.target.value),
        onFocus: () => Rr(h),
        type: "email",
        value: f
      }
    ),
    /* @__PURE__ */ D.jsx("div", { className: br.buttons, ref: h, children: /* @__PURE__ */ D.jsx(xr, { disabled: v, label: "Continue" }) })
  ] });
}, Jn = "cvg-pincode_GXQJr", Hn = {
  pincode: Jn
}, Xn = 8, Zn = 37, Qn = 38, ea = 39, ra = 40, ta = 46, xe = [], na = ({ onFocus: t }) => {
  const { code: f, error: p, languageId: u, setCode: b } = ie(), l = (p == null ? void 0 : p.code) === We.NotAuthorizedException, h = (o) => {
    let _ = String(o.target.value), g = Number(o.target.dataset.id);
    if (_ !== "") {
      const B = [...f];
      _.split("").map((M, V) => (Number(o.target.dataset.id) + V < Oe && (B[Number(o.target.dataset.id) + V] = M, g = g + 1 < Oe ? g + 1 : g), !1)), y(xe[g]), b(B);
    }
  }, v = (o) => {
    const _ = Number(o.target.dataset.id), g = xe[_ + 1], B = xe[_ - 1];
    switch (o.keyCode) {
      case Xn:
        o.preventDefault(), d(_), y(B);
        break;
      case ta:
        o.preventDefault(), d(_);
        break;
      case Zn:
        o.preventDefault(), y(B);
        break;
      case ea:
        o.preventDefault(), y(g);
        break;
      case Qn:
      case ra:
        o.preventDefault();
        break;
    }
  }, m = (o) => {
    o.preventDefault(), o.target.focus(), o.target.setSelectionRange(0, o.target.value.length), t();
  }, y = (o) => {
    o && o.focus();
  }, d = (o) => {
    b(f.map((_, g) => g === o ? "" : _));
  };
  return /* @__PURE__ */ D.jsx("div", { className: Hn.pincode, children: f.map((o, _) => /* @__PURE__ */ D.jsx(
    "input",
    {
      "aria-label": K.getValue("Code", u),
      autoComplete: "off",
      "data-id": _,
      "data-testid": `pin_${_}`,
      disabled: l,
      inputMode: "numeric",
      name: `pin_${_}`,
      onChange: (g) => h(g),
      onClick: (g) => m(g),
      onContextMenu: (g) => g.preventDefault(),
      onFocus: (g) => m(g),
      onInput: (g) => h(g),
      onKeyDown: (g) => v(g),
      onMouseUp: (g) => g.preventDefault(),
      ref: (g) => xe[_] = g,
      type: "text",
      value: o
    },
    `pin_${_}`
  )) });
}, aa = () => {
  const { languageId: t, reset: f } = ie();
  return /* @__PURE__ */ D.jsx(
    "button",
    {
      "aria-label": K.getValue("Back", t),
      className: Ue.cancel,
      onClick: f,
      tabIndex: "-1",
      type: "button"
    }
  );
}, ia = () => {
  const { languageId: t, reset: f } = ie();
  return /* @__PURE__ */ D.jsx("button", { className: Ue.reset, onClick: f, type: "button", children: K.getValue("Start Over", t) });
}, oa = "cvg-code_-D8MI", sa = "cvg-slideIn_DjmpG", ca = "cvg-buttons_cqHr6", hr = {
  code: oa,
  slideIn: sa,
  buttons: ca
}, ua = () => {
  const { code: t, email: f, error: p, isSubmitting: u, languageId: b, submitCode: l, verifyCodeFn: h } = ie(), v = _r(), m = u || t.join("").length < Oe, y = (p == null ? void 0 : p.code) === We.NotAuthorizedException;
  return /* @__PURE__ */ D.jsxs("form", { className: hr.code, onSubmit: (d) => l({ e: d, code: t, verifyCodeFn: h }), children: [
    /* @__PURE__ */ D.jsxs("p", { children: [
      K.getValue("Enter verification code sent to:", b),
      " ",
      /* @__PURE__ */ D.jsx("span", { children: f })
    ] }),
    /* @__PURE__ */ D.jsx(Tr, {}),
    /* @__PURE__ */ D.jsx(na, { onFocus: () => Rr(v) }),
    /* @__PURE__ */ D.jsxs("div", { className: hr.buttons, ref: v, children: [
      y && /* @__PURE__ */ D.jsx(ia, {}),
      !y && /* @__PURE__ */ D.jsx(aa, {}),
      !y && /* @__PURE__ */ D.jsx(xr, { disabled: m, label: "Submit" })
    ] })
  ] });
}, la = async ({ e: t, code: f, verifyCodeFn: p }) => {
  t.preventDefault(), await p(f.join(""));
}, fa = async ({ auth: t, e: f, email: p, languageId: u }) => (f.preventDefault(), !await t.isExistingUser(p) && await t.createUser(p, u), { verifyCodeFn: await t.login(p) }), da = ({ onStepChange: t, redirectCallback: f, theme: p }) => {
  var y;
  const u = {
    currentStep: we.enterEmail,
    code: new Array(Oe).fill(""),
    email: ""
  }, [b, l] = Gr((d, o) => {
    const { email: _, code: g, currentStep: B } = o || {};
    switch (o.type) {
      case "RESET":
        return u;
      case "SET_CURRENT_STEP":
        return { ...d, currentStep: B };
      case "SET_CODE":
        return { ...d, code: g };
      case "SET_EMAIL":
        return { ...d, email: _ };
    }
  }, u);
  ir(() => {
    document.documentElement.style.setProperty("--theme-color", (p == null ? void 0 : p.color) || "#555");
  }, []), ir(() => {
    t && t(b.currentStep);
  }, [b.currentStep]);
  const h = or(fa, {
    onSuccess: () => l({ type: "SET_CURRENT_STEP", currentStep: we.confirmCode })
  }), v = or(la, {
    onSuccess: f
  });
  return {
    callbacks: {
      reset: () => {
        l({ type: "RESET" }), h.reset(), v.reset();
      },
      setCode: (d) => l({ type: "SET_CODE", code: d }),
      setEmail: (d) => l({ type: "SET_EMAIL", email: d }),
      submitCode: v.submit,
      submitEmail: h.submit,
      verifyCodeFn: (y = h.data) == null ? void 0 : y.verifyCodeFn
    },
    error: h.error || v.error,
    isSubmitting: h.isSubmitting || v.isSubmitting,
    state: b
  };
}, pa = ({ auth: t, className: f, languageId: p = "en", onStepChange: u, redirectCallback: b, theme: l }) => {
  const { callbacks: h, error: v, isSubmitting: m, state: y } = da({
    onStepChange: u,
    redirectCallback: b,
    theme: l
  }), d = y.currentStep === we.enterEmail, o = y.currentStep === we.confirmCode;
  return /* @__PURE__ */ D.jsx(Jr, { context: { auth: t, error: v, isSubmitting: m, languageId: p, ...h, ...y }, children: /* @__PURE__ */ D.jsxs("div", { className: f, children: [
    d && /* @__PURE__ */ D.jsx(Gn, {}),
    o && /* @__PURE__ */ D.jsx(ua, {})
  ] }) });
};
pa.propTypes = {
  auth: ge.any.isRequired,
  className: ge.string,
  languageId: ge.string,
  onStepChange: ge.func,
  redirectCallback: ge.func.isRequired,
  theme: ge.object
};
export {
  pa as OtpLogin
};
//# sourceMappingURL=bundle.js.map
